import React from 'react';

const linkedin = (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
     viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}}>
    <g id="OUTLINE_copy">
    <path className="p1" d="M23.247,21.927v-5.36c0-2.872-1.533-4.208-3.577-4.208c-1.649,0-2.388,0.907-2.8,1.544v-1.324
        h-3.107c0.041,0.877,0,9.348,0,9.348h3.107v-5.221c0-0.279,0.02-0.558,0.103-0.757c0.224-0.558,0.735-1.136,1.593-1.136
        c1.125,0,1.574,0.857,1.574,2.113v5.001L23.247,21.927L23.247,21.927z M10.49,11.303c1.083,0,1.758-0.718,1.758-1.616
        c-0.02-0.917-0.675-1.614-1.738-1.614S8.753,8.77,8.753,9.687c0,0.897,0.675,1.616,1.717,1.616H10.49z M12.043,21.927v-9.348H8.937
        v9.348H12.043z"/>
</g>
</svg>)

export default linkedin;




// WEBPACK FOOTER //
// ./src/components/Websites/About/SVGs/linkedin.js